import { render, staticRenderFns } from "./MaterialDropdown.vue?vue&type=template&id=957a2cb6"
import script from "./MaterialDropdown.vue?vue&type=script&lang=js"
export * from "./MaterialDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.17_css-loader@6.11.0_webpack@5.100.1__lodash@4_556b3bfb3afe7b52a2e5a0e28dba9672/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports